<aza-rws-multi-registration-form
    *ngIf="uiState && config && allParticipantFields"
    [state]="uiState"
    [allParticipantFields]="allParticipantFields"
    [subParticipantFieldIds]="config?.subparticipant_form_field_ids"
    [config]="config"
    (action)="onAction($event)"
></aza-rws-multi-registration-form>
